export default __webpack_public_path__ + "ui/assets/img/info-invert-error-32.svg";